import { render, staticRenderFns } from "./PointsService.vue?vue&type=template&id=7350c9d0&scoped=true"
import script from "./PointsService.vue?vue&type=script&lang=js"
export * from "./PointsService.vue?vue&type=script&lang=js"
import style0 from "./PointsService.vue?vue&type=style&index=0&id=7350c9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350c9d0",
  null
  
)

export default component.exports